import SendMessageList from './sendMessageList';
import SendMessageShow from './sendMessageShow';
import SendMessageCreate from './sendMessageCreate';

export default {
    list: SendMessageList,
    show: SendMessageShow,
    create: SendMessageCreate
}